let accordionItems = document.querySelectorAll('.accordion');
  accordionItems.forEach(function(item) {
  let header = item.querySelector('.accordion-header');
  let content = item.querySelector('.accordion__content');
  content.style.display = 'none';

    header.addEventListener('click', function (event) {
    let accordionElements = document.querySelectorAll('.accordion');

    accordionElements.forEach(function(item) {
      let comp_header = item.querySelector('.accordion-header');
      if (comp_header.id !== event.currentTarget.id) {
        let com_header = item.querySelector('.accordion-header');
        let com_content = item.querySelector('.accordion__content');
        let com_details = item.querySelector('.details');
        com_header.setAttribute('aria-expanded', false);
        com_details.removeAttribute('open');
        com_content.style.display = 'none';
        let arrow = com_header.querySelector('svg');
        arrow.style.transform = 'rotate(90deg)';
      }
    });

    let arrow = header.querySelector('svg');
    if (content.style.display === 'none') {
      content.style.display = 'block'
      arrow.style.transform = 'rotate(-90deg)';
    } else {
      content.style.display = 'none'
      arrow.style.transform = 'rotate(90deg)';
    }
  });
});